import request from './request.js';
import {requestbody} from './request.js'
//开票数据台账导入
export async function inputCertification_importExcel (params = {}) {
	return await request('/input-certification/file/upload', 'post', params)
}
//开票数据台账分页查询
export async function inputCertification_page (params = {}) {
	return await request('/input-certification/page', 'get', params)
}
//开票数据台账删除
export async function inputCertification_del (params = {}) {
	return await request('/input-certification/delete', 'post', params)
}